import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Table, TableBody, TableHead, TableRow, TableCell } from "../Table";
import { Text } from "../Text";
import { SheetCell } from "./SheetCell/SheetCell";
import { DeleteRowButton } from "./DeleteRowButton/DeleteRowButton";
import { AddRowButton } from "./AddRowButton/AddRowButton";
import "./Sheet.scss";

export class Sheet extends React.Component {
  static propTypes = {
    /** Additional class names for the component */
    className: PropTypes.string,
    /** Contains the meta data of each column */
    columns: PropTypes.arrayOf(
      PropTypes.shape({
        /** id is used as a key for the to orgainze the records by column */
        id: PropTypes.string.isRequired,
        /** The column label for users to see */
        name: PropTypes.string.isRequired,
        /** Allows for some columns to not be editable by users */
        editable: PropTypes.bool,
        /** Allows for some columns to require users to enter data */
        required: PropTypes.bool,
        /** Used to select which input component is rendered for a specific column */
        type: PropTypes.string,
      })
    ),
    rows: PropTypes.arrayOf(PropTypes.object),
    /** Callback function for when a record is changed */
    onRecordChange: PropTypes.func,
    /** Callback function for when a row is added */
    onRowAdd: PropTypes.func,
    /** Callback function for when a row is deleted */
    onRowDelete: PropTypes.func,
    /** gives the sheet a fixed width */
    width: PropTypes.string,
  };

  renderColumnLabels = () => {
    const { columns, onRowDelete } = this.props;

    return (
      <TableRow>
        {columns.map((column) => (
          <TableCell
            className="Sheet__columnLabel"
            key={column.id}
            dataTestId="sheet-column-head"
          >
            <Text type="H6" className="columnLabel__text">
              {column.name}
            </Text>
          </TableCell>
        ))}
        {onRowDelete && <TableCell className="Sheet__deleteColumn" />}
      </TableRow>
    );
  };

  renderRows = () => {
    const { onRowDelete, rows } = this.props;
    return rows.map((row, index) => (
      <TableRow key={index} dataTestId="sheet-table-row">
        {this.renderRecords(row, index)}
        {onRowDelete && (
          <DeleteRowButton index={index} onRowDelete={onRowDelete} />
        )}
      </TableRow>
    ));
  };

  renderRecords = (row, index) => {
    const { columns, onRecordChange } = this.props;
    return columns.map((column) => {
      return (
        <SheetCell
          key={column.id}
          index={index}
          onRecordChange={onRecordChange}
          column={column}
          row={row}
        />
      );
    });
  };

  render() {
    const { className, onRowAdd, width } = this.props;
    const sheetClass = classNames("Sheet", className);

    return (
      <div className={sheetClass} data-testid="sheet">
        <Table dataTestId="sheet-table" style={{ width }}>
          <TableHead className="Sheet__head" dataTestId="sheet-table-head">
            {this.renderColumnLabels()}
          </TableHead>
          <TableBody dataTestId="sheet-table-body">
            {this.renderRows()}
          </TableBody>
        </Table>
        {onRowAdd && <AddRowButton onRowAdd={onRowAdd} />}
      </div>
    );
  }
}

export default Sheet;
